import en from "./en.json";
import tosEn from "./tos.json";

export default {
  ...en,
  ...tosEn,
};
